import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import Table from "components/Admin/ArchivedBatches/ArchivedBatches";

import { useDispatch, useSelector } from "react-redux";
import { getApprovedBatches } from "store/actions/archivedBatches";

const ApprovedBatches = () => {
  const dispatch = useDispatch();
  const { approvedBatches } = useSelector((state) => state.archivedBatches);
  const [page, setPage] = useState(
    approvedBatches ? approvedBatches.pag.page : 1
  );
  const [amount, setAmount] = useState(
    approvedBatches ? approvedBatches.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    approvedBatches ? approvedBatches.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    approvedBatches ? approvedBatches.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState(
    approvedBatches ? approvedBatches.pag.search_by : "branch_name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getApprovedBatches(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, dispatch]);

  const showBatchHandler = (id) => {
    history.push("/admin/archived-batches/item/" + id);
  };
  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Approved Archived Batches</h4>
        </CardHeader>
        <CardBody>
          {approvedBatches && (
            <div>
              <Table
                rows={approvedBatches.data}
                totalRows={approvedBatches.pag.total}
                rowsPerPage={amount}
                setRowsPerPage={setAmount}
                order={orderType}
                setOrder={setOrderType}
                orderBy={orderField}
                setOrderBy={setOrderField}
                page={page - 1}
                setPage={setPage}
                showBatch={showBatchHandler}
                searchHandler={setSearchValue}
                searchValue={searchValue}
                selectedSearchBy={searchBy}
                handleSearchByChange={setSearchBy}
                isApproved={true}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default ApprovedBatches;
